import React from 'react';
import { IonButton } from '@ionic/react';
import 'components/wind-down-banner/WindDownBanner.scss';

interface WindDownBannerProps {
  onSwitchToDigital: () => void;
}

const WindDownBanner: React.FC<WindDownBannerProps> = ({
  onSwitchToDigital
}) => {
  return (
    <div className="hk-wind-down-banner-container">
      <div className="hk-wind-down-banner">
        <div>
          <p className="hk-wind-down-banner-heading">
            The HomeKeep Full Service program — including in-home maintenance
            visits — is no longer available for renewal.
          </p>
          <p>
            HomeKeep Digital preserves everything you've built — your
            appointment history, home profile, and maintenance records — plus a
            personalized plan to keep your home on track going forward.
          </p>
          <p>
            Your first year is on us — use code <strong>FSNEXT</strong> at
            checkout. Questions? Visit our{' '}
            <a
              href="https://avidwarranty.com/homekeep/education-guides/article/2jK6Wso9EAX6mlPSpFOT"
              target="_blank"
              rel="noopener noreferrer"
            >
              FAQ
            </a>
            .
          </p>
        </div>
        <IonButton
          expand="block"
          strong={true}
          className="hk-wind-down-banner-button ion-margin-vertical"
          onClick={onSwitchToDigital}
        >
          Switch to Digital
        </IonButton>
      </div>
    </div>
  );
};

export default WindDownBanner;
